import AssetService from '@ane/core/lib/services/AssetService';
import Logger from '@ane/core/lib/services/logging/Logger';
import NavigationService from '@ane/core/lib/services/NavigationService';
import LocalStorageService from '@ane/core/lib/services/LocalStorageService';
import { BST_ENABLE_MSAL_TESTING } from '@ane/core/lib/constants/QueryString.constants';
import { LOCAL_STORAGE_CONSTANTS } from '@ane/core/lib/constants/LocalStorage.constants';

/**
 * Msal testing
 * Ensure that this value is set before all other application code is reached
 * Specifically MsalAuthService
 */
const enableMsalTesting = NavigationService.getUrlParam(BST_ENABLE_MSAL_TESTING);
if (enableMsalTesting === '1') {
  LocalStorageService.setItem(LOCAL_STORAGE_CONSTANTS.enableMsalTesting, true);
}

/**
 * Authenticate and get all of the necessary config data to bootstrap ExP
 * (User, Asset Url(s), Treatment Variables)
 */
export const init = async (bundle: string, loginUserAndGetTreatmentAssignment: boolean) => {
  Logger.trackMetric({
    name: `PLT:Bootstrap:${bundle}:init`,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });

  // get assetURL
  Logger.trackMetric({
    name: `PLT:Bootstrap:${bundle}:init:getAssetUrl:before`,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });
  await AssetService.getAssetUrl().catch((e: Error) => {
    Logger.trackMetric({
      name: `PLT:Bootstrap:${bundle}:init:getAssetUrl:error`,
      average: performance.now(),
      properties: {
        url: document.location.href,
        error: e,
      },
    });
  });
  __webpack_public_path__ = AssetService.assetUrl;
};
